export interface SwipeSample {
  deltaX: number;
  deltaY: number;
  elapsedMs: number;
}

const DISMISS_DISTANCE_PX = 48;
const FLICK_DISTANCE_PX = 18;
const FLICK_VELOCITY_PX_MS = 0.45;

/**
 * A deliberate upward gesture wins either by distance or by velocity. In both
 * cases it must be more vertical than horizontal, so scrolling a horizontal
 * control under a wide toast cannot accidentally close it.
 */
export function isDismissSwipe({ deltaX, deltaY, elapsedMs }: SwipeSample): boolean {
  const upward = -deltaY;
  const vertical = upward > Math.abs(deltaX);
  if (!vertical || upward < FLICK_DISTANCE_PX) return false;

  const velocity = upward / Math.max(elapsedMs, 1);
  return upward >= DISMISS_DISTANCE_PX || velocity >= FLICK_VELOCITY_PX_MS;
}
